import { useMemo } from "react"

import {
  ERP_CONTROLLED_TOOLTIP,
  readControlledFields,
  type ErpLockableField,
} from "~/constants/erpFields"
import { useCompany } from "~/hooks/useCompany"

/**
 * Reads the company query every surface already subscribes to, so gating an editor costs no
 * extra request.
 */
export function useErpLockedFields() {
  const { data: company } = useCompany()

  return useMemo(() => {
    const locked = new Set(readControlledFields(company?.erpControlledFields))
    const isFieldLocked = (field: ErpLockableField) => locked.has(field)

    return {
      isFieldLocked,
      lockReason: (field: ErpLockableField) =>
        isFieldLocked(field) ? ERP_CONTROLLED_TOOLTIP : undefined,
    }
  }, [company?.erpControlledFields])
}
